import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Select, Table } from 'semantic-ui-react';
import {
  filterManufacturersByPlatform,
  filterOsesByPlatform,
} from '../../../../services/deviceService';
import actions from '../../../../redux/actions';
import { DevicePlatform } from '../../../../types/DevicePlatform';
import { OperationStatus } from '../../../../types/OperationStatus';
import { getPlatformPrettyName } from '../../../../services/deviceService';
import { searchFromStart } from '../../../../util/utils';

const mapStateToProps = (state) => {
  return {
    addDeviceStatus: state.addDeviceStatus,
    user: state.user,
    manufacturers: state.devices.manufacturers,
    models: state.devices.models,
    oses: state.devices.oses,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addDevice: (data) => dispatch(actions.addDevice(data)),
    deleteDevice: (data) => dispatch(actions.deleteDevice(data)),
  };
};

const platformOptions: any[] = Object.entries(DevicePlatform).reduce((result, [key, val]) => {
  if (val !== DevicePlatform.Desktop && val !== DevicePlatform.WindowsDesktop && val !== DevicePlatform.WindowsLaptop ) {
    result.push({
      text: getPlatformPrettyName(val),
      key: DevicePlatform[key],
      value: DevicePlatform[key],
    });
  }

  return result;
}, [] as any[]);

class Devices extends Component<any> {
  public state: any;

  constructor(props) {
    super(props);
    this.state = {
      newPlatformId: '',
      newManufacturerId: '',
      newModelId: '',
      newOsId: '',
      manufacturers: [],
      models: [],
      oses: [],
    };
  }

  onChange = (event, data) => {
    switch (data.name) {
      case 'newPlatformId': {
        const platformId = data.value;
        const manufacturers = filterManufacturersByPlatform(
          platformId,
          this.props.manufacturers,
          this.props.models
        );

        let newManufacturerId = '';
        let models: any[] = [];
        let newModelId = '';   

        // TODO maybe same for models, OSes etc
        if (manufacturers.length === 1) {
          newManufacturerId = manufacturers[0].id;
          models = this.props.models
            .filter((el) => el.platformId === data.value)
            .filter((el) => el.manufacturerId === newManufacturerId);
            
          if( models.length === 1 ) {            
            newModelId = models[0].id;            
          }
        }

        const oses = filterOsesByPlatform(data.value, this.props.oses);

        const newState: Record<string, any> = {
          ...this.state,
          newPlatformId: data.value,
          newManufacturerId,
          newModelId,
          newOsId: '',
          manufacturers,
          models,
          oses,
        };

        return this.setState(newState);
      }

      case 'newManufacturerId': {
        const models = this.props.models
          .filter((el) => el.platformId === this.state.newPlatformId)
          .filter((el) => el.manufacturerId === data.value);

        let newModelId = '';

        if( models.length === 1 ) {            
          newModelId = models[0].id;
        }

        const newState: Record<string, any> = {
          ...this.state,
          newManufacturerId: data.value,
          newModelId,
          newOsId: '',
          models,
        };

        return this.setState(newState);
      }

      case 'newModelId':
        return this.setState({
          ...this.state,
          newModelId: data.value,
          newOsId: '',
        });

      case 'newOsId':
        return this.setState({
          ...this.state,
          newOsId: data.value,
        });

      default:
        return;
    }
  };

  onAddDevice = () => {
    // TODO send only modelId and osId, populate platformId, manufacturerId and name on the server side
    this.props.addDevice({
      platformId: this.state.newPlatformId,
      manufacturerId: this.state.newManufacturerId,
      modelId: this.state.newModelId,
      osId: this.state.newOsId,
    });
  };

  onDeleteDevice = (event, data) => {
    this.props.deleteDevice({
      modelId: data['data-device-model-id'],
      osId: data['data-device-os-id'],
    });
  };

  isDeviceAlreadyExists = (device) => {
    const result = this.props.user.devices.find(
      (el) => el.modelId === device.modelId && el.osId === device.osId
    );

    if (result) {
      return true;
    }

    return false;
  };

  render() {
    const user = this.props.user;

    const vendorOptions = this.state.manufacturers.map((el) => ({
      key: el.id,
      value: el.id,
      text: el.name,
    }));

    const modelOptions = this.state.models.map((el) => ({
      key: el.id,
      value: el.id,
      text: el.name,
    }));

    const osOptions = this.state.oses
      .map((el) => ({
        key: el.id,
        value: el.id,
        text: el.name,
      }))
      .reverse();

    const processing = this.props.addDeviceStatus.status === OperationStatus.processing;
    const disabled =
      processing ||
      !this.state.newPlatformId ||
      !this.state.newManufacturerId ||
      !this.state.newModelId ||
      !this.state.newOsId ||
      this.isDeviceAlreadyExists({
        modelId: this.state.newModelId,
        osId: this.state.newOsId,
      });

    // TODO ensure the default values for manufacturers, models and oses are always set
    const manufacturers = this.props.manufacturers || [];
    const models = this.props.models || [];
    const oses = this.props.oses || [];

    return (
      <div className="devices">
        <h3>Add device</h3>
        <div className="add">
          <div className="input-devices">
            <span>Device type</span>
            <Select
              name="newPlatformId"
              options={platformOptions}
              value={this.state.newPlatformId}
              onChange={this.onChange}
            />
          </div>
          <div className="input-devices">
            <span>Device brand</span>
            <Select
              name="newManufacturerId"
              options={vendorOptions}
              disabled={vendorOptions.length === 1}
              value={this.state.newManufacturerId}
              onChange={this.onChange}
              search={searchFromStart}
            />
          </div>
          <div className="input-devices">
            <span>Device model</span>
            <Select
              name="newModelId"
              options={modelOptions}
              disabled={modelOptions.length === 1}
              value={this.state.newModelId}
              onChange={this.onChange}
              search={searchFromStart}
            />
          </div>
          <div className="input-devices">
            <span>Device OS</span>
            <Select
              name="newOsId"
              options={osOptions}
              value={this.state.newOsId}
              onChange={this.onChange}
              search={searchFromStart}
            />
          </div>

          <Button
            className="add-device-btn"
            primary
            loading={processing}
            disabled={disabled}
            onClick={this.onAddDevice}
          >
            Add device
          </Button>
        </div>

        <div>
          <h3>My devices</h3>
          <Table compact celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Brand</Table.HeaderCell>
                <Table.HeaderCell>Model</Table.HeaderCell>
                <Table.HeaderCell>OS</Table.HeaderCell>
                <Table.HeaderCell width="1"></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {user.devices.map((el, i) => {
                const model = models.find((mod) => mod.id === el.modelId);
                const modelName = model ? model.name : `Unknown model ${el.modelId}`;

                const manufacturerId = model ? model.manufacturerId : -1;
                const manufacturer = manufacturers.find((man) => man.id === manufacturerId);
                const manufacturerName = manufacturer
                  ? manufacturer.name
                  : `Unknown manufacturer ${manufacturerId}`;

                const os = oses.find((os) => os.id === el.osId);
                const osName = os ? os.name : `Unknown OS ${el.osId}`;

                return (
                  <Table.Row key={i}>
                    <Table.Cell>{manufacturerName}</Table.Cell>
                    <Table.Cell>{modelName}</Table.Cell>
                    <Table.Cell>{osName}</Table.Cell>
                    <Table.Cell>
                      <Button
                        negative
                        compact
                        size="mini"
                        data-device-model-id={el.modelId}
                        data-device-os-id={el.osId}
                        onClick={this.onDeleteDevice}
                      >
                        Delete
                      </Button>
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Devices));
